export default __webpack_public_path__ + "static/media/location-dot-solid.4576028d.svg";